<style src="./ProfessionalVideo.scss" lang="scss" scoped></style>
<template>
  <!-- PRE SALA -->
  <section v-if="!showVideo" class="form-all">
    <div class="form" @keydown="handleEnterKey">
      <div class="title">Portal Profissional</div>
      <div class="title mb">Videoconferência</div>
      <div class="subtitle">Digite o CPF do paciente</div>
      <InputText placeholder="CPF"
        mask="###.###.###-##"
        v-model="cpf"
      />
      <div class="btn" @click="clickAskPatientRoom">Entrar na Sala</div>
    </div>
  </section>
  <!-- SALA -->
  <section v-else class="video-all">
    <section class="room">
      <div class="video-screen">
        <div class="expand_stream" id="expand_stream"></div>
      </div>

      <div class="video-local">
        <div class="local_stream" id="local_stream"></div>
      </div>

      <div class="acts">
        <div class="btn-circle" :class="{'green': isBtnMicroOn}" @click="onClickMicrophone">
          <IconBtnMicroOff v-if="!isBtnMicroOn"/>
          <IconBtnMicroOn v-else/>
        </div>
        <div class="btn-circle" :class="{'green': isBtnCamOn}" @click="onClickCamera">
          <IconBtnCamOff v-if="!isBtnCamOn"/>
          <IconBtnCamOn v-else/>
        </div>
        <div class="btn-circle red" @click="onClickExit">
          <i class="fas fa-door-open"></i>
        </div>
      </div>
    </section>
  </section>
</template>

<script>
import ApiService from './services/ApiService'
import FirebaseService from './services/FirebaseService'
import AgoraService from './services/AgoraService'

import IconBtnCamOff from '@/assets/icons/IconBtnCamOff'
import IconBtnMicroOff from '@/assets/icons/IconBtnMicroOff'
import IconBtnCamOn from '@/assets/icons/IconBtnCamOn'
import IconBtnMicroOn from '@/assets/icons/IconBtnMicroOn'
import InputText from '@/components/input/text/InputText'

export default {
  name: 'CabineProfessionalVideo',
  props: {
  },
  components: {
    IconBtnCamOff,
    IconBtnMicroOff,
    IconBtnCamOn,
    IconBtnMicroOn,
    InputText
  },
  
  data () {
    return {
      funId: '0',
      funName: 'Fun Teste',
      cpf: '13407387750',

      enteredRoom: false,
      showVideo: false,

      isBtnMicroOn: true,
      isBtnCamOn: true
    }
  },
  
  watch: {
  },

  beforeDestroy() {
  },

  async beforeMount() {
    this.FirebaseService = new FirebaseService()
    this.ApiService = new ApiService()
    setTimeout(() => {
      document.title = 'Teste - Profissional'
    }, 500)
  },

  async mounted() {
    this.AgoraService = new AgoraService(this.patient, this.userLogin)
  },
  
  methods: {
    /**
     * Detecta a tecla "Enter" e chama o método `clickAskPatientRoom` se pressionada.
     * @param {KeyboardEvent} event - O evento de teclado que foi disparado.
     */
    handleEnterKey(event) {
      if (event.key === 'Enter') {
        this.clickAskPatientRoom()
      }
    },

    /**
     * Envia uma pergunta para o paciente e aguarda a resposta.
     * Atualiza o campo 'pergunta' no Firebase, depois espera a 
     * resposta por um determinado tempo.
     * Se a resposta for 'resposta', abre a sala de telessaúde, 
     * caso contrário, remove a sala.
     */
    clickAskPatientRoom () {
      this.FirebaseService.updateFirebaseRoom(this.cpf, 'pergunta', 'pergunta')
      setTimeout(() => {
        this.FirebaseService.onceRoomByCpf(this.cpf, (room) => {
          const valueQuestion = room.agoraSdk.pergunta
          console.log('valueQuestion', valueQuestion)
          if (valueQuestion === `resposta`) {
            this.openRoom()
            return
          }
          this.FirebaseService.removeTelehealthRoom(this.cpf)
        })
      }, 5 * 1000)
    },

    /**
     * Abre a sala de vídeo, exibindo o vídeo e iniciando 
     * o listener de sala no Firebase.
     */
    openRoom () {
      const cpfFormat = this.cpf.replace(/[.-]/g, '');
      this.showVideo = true
      this.listenerRoomByCpf(cpfFormat)
    },

    /**
     * Inicia o listener para mudanças na sala com base no CPF fornecido.
     * @param {string} cpf - O CPF do paciente para ouvir mudanças na sala.
     */
    async listenerRoomByCpf(cpf) {
      this.FirebaseService.listenerRoomByCpf(cpf, async (payload) => {
        this.controllerPayloadListenerRoom(payload, cpf);
      });
    },

    /**
     * Controla a lógica de acordo com o payload recebido sobre a sala.
     * @param {Object} payload - Dados recebidos sobre a sala.
     * @param {string} cpf - O CPF do paciente.
     */
    async controllerPayloadListenerRoom (payload, cpf) {
      if (!payload) { // Sala não existe ou payload é nulo.
        this.roomPayloadNull(cpf);
        return;
      }
      if (payload.changeType === 'modified') { // Sala foi modificada.
        this.roomPayloadModified(payload.data, cpf);
        return;
      }
      if (payload.changeType === 'added') { // Sala foi criada.
        this.roomPayloadAdded(payload.data, cpf);
        return;
      }
      if (payload.changeType === 'removed') { // Sala foi destruída.
        this.roomPayloadRemoved(cpf);
        return;
      }
      // Caso não se encaixe em nenhum dos casos acima.
      console.error('[ProfessionalVideo] (controllerPayloadListenerRoom)', 'Não entrou em nenhum IF');
    },

    /**
     * Ação a ser tomada quando o payload da sala é nulo.
     * @param {string} cpf - O CPF do paciente.
     */
    async roomPayloadNull (cpf) {
      console.log('(Payload Sala) - null. CPF', cpf);
      await this.actLeaveRoom();
    },
    
    /**
     * Ação a ser tomada quando a sala é destruída.
     * @param {string} cpf - O CPF do paciente.
     */
    async roomPayloadRemoved (cpf) {
      console.warn('(Payload Sala) - removido. CPF', cpf);
      await this.actLeaveRoom();
      this.FirebaseService._setMovimentLog(`acao profissional`, `Saindo da Sala -  Sala Destruida`, cpf, {})
      this.showVideo = false
    },

    /**
     * Ação a ser tomada quando uma nova sala é criada.
     * @param {Object} payload - Dados do payload.
     * @param {string} cpf - O CPF do paciente.
     */
    async roomPayloadAdded(payload, cpf) {
      console.log('(Payload Sala) - adicionado. CPF', cpf);
      await this.actLeaveRoom();
      if (payload) {
        this.actEnterRoom(payload.agoraSdk, cpf);
      }
    },
    
    /**
     * Ação a ser tomada quando uma sala é modificada.
     * @param {Object} payload - Dados do payload.
     * @param {string} cpf - O CPF do paciente.
     */
    async roomPayloadModified(payload, cpf) {
      console.log('(Payload Sala) - modificado. CPF', cpf);
      if (payload && !this.enteredRoom) {
        await this.actLeaveRoom();
        this.actEnterRoom(payload.agoraSdk, cpf);
      }
    },

    /**
     * Entra na sala do Agora com base no payload e CPF fornecido.
     * @param {Object} payload - Dados do payload.
     * @param {string} cpf - O CPF do paciente.
     */
    async actEnterRoom(payload, cpf) {
      this.enteredRoom = true
      await this.AgoraService.enterRoom(payload, cpf, this.funId);
      const funStreamId = `funId_${this.funId}`
      this.FirebaseService.updateFirebaseRoom(cpf, 'funStreamId', funStreamId)
      setTimeout(() => {
        this.FirebaseService.updateFirebaseRoom(cpf, 'funNome', this.funName)
      }, 50)
    },

    /**
     * Sai da sala do Agora.
     */
    async actLeaveRoom() {
      await this.AgoraService.leaveRoom();
      this.enteredRoom = false
    },

    // Funções de manipulação de interface do usuário

    /**
     * Função chamada ao clicar no botão de saída.
     */
    onClickExit() {
      this.actLeaveRoom();
      this.showVideo = false
      window.location.reload();
    },

    /**
     * Função chamada ao clicar no botão da câmera para ativar/desativar vídeo.
     */
    onClickCamera() {
      this.AgoraService.videoOnOff((response) => {
        if (response.status) {
          this.isBtnCamOn = true;
        } else {
          this.isBtnCamOn = false;
        }
      });
    },

    /**
     * Função chamada ao clicar no botão do microfone para ativar/desativar áudio.
     */
    onClickMicrophone() {
      this.AgoraService.audioOnOff((response) => {
        if (response.status) {
          this.isBtnMicroOn = true;
        } else {
          this.isBtnMicroOn = false;
        }
      });
    }
  }
}
</script>
